import React, {useEffect, useState} from 'react';

import ActivityIndicator from '../../components/ui-controls/ActivityIndicator';
import Button from '../../components/ui-controls/Button';
import ContentView from '../../components/ui-controls/layout/ContentView';
import Text from '../../components/ui-controls/Text';
import config from '../../config';
import {AirtablePromotionItem} from '../../models/airtable';
import {AppRoute} from '../../models/AppRoute';
import {RootStoreSelectionNavigatorScreenProps} from '../../models/navigationTypes';
import apiService from '../../transport/apiService';
import {isGiftCardsPromotion} from '../../utils/giftCards';
import {PromotionDetailScreenStandalone} from '../articles/PromotionDetailScreen';

const storeNumber = config.DEFAULT_STORE;
const storeState = config.DEFAULT_STORE_STATE;

type Props =
  RootStoreSelectionNavigatorScreenProps<AppRoute.ROOT_GIFT_CARDS_PROMOTION>;

const GiftCardsPromotionDetailRootFlowScreen = ({navigation}: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [promotion, setPromotion] = useState<AirtablePromotionItem>();

  useEffect(() => {
    async function initialise() {
      setIsLoading(true);
      const promotions =
        (await apiService.getPromotions(storeNumber, storeState)) || [];
      const giftCardPromotion = promotions.find(
        isGiftCardsPromotion,
      ) as AirtablePromotionItem;
      setPromotion(giftCardPromotion);
      setIsLoading(false);
    }
    initialise();
  }, []);

  if (isLoading) {
    return (
      <ContentView testID="promotion-detail-screen">
        <ActivityIndicator />
      </ContentView>
    );
  }

  const handleGoBackToStoreSelection = () =>
    navigation.navigate(AppRoute.MY_STORE_SUBURB_SELECTION);

  const extraContent = (
    <Button
      onPress={handleGoBackToStoreSelection}
      title="Go back"
      type="outline"
    />
  );

  if (promotion) {
    return (
      <ContentView testID="promotion-detail-screen">
        <PromotionDetailScreenStandalone
          isLastCompetitionRemaining={false}
          promotion={promotion}
          navigation={navigation}
          isRootStoreSelectionFlow={true}
          extraContent={extraContent}
        />
      </ContentView>
    );
  }

  return (
    <ContentView testID="promotion-detail-screen">
      <Text style={{marginVertical: 16}}>
        Gift Cards are not available yet. Please come back soon.
      </Text>
      <Button
        onPress={handleGoBackToStoreSelection}
        title="Go back"
        type="solid"
      />
    </ContentView>
  );
};

export default GiftCardsPromotionDetailRootFlowScreen;
